module.exports = __webpack_public_path__ + "static/img/photo04.37b1cb8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Tokyo/photo04.jpg
// module id = BwNd
// module chunks = 0